export const AddressEditorDropdownModule = angular
    .module('app.components.addressEditor.addressEditorDropdown', [])
    .directive('addressEditorDropdown', () => {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                availableoptions: '=',
                optionselect: '=',
                selectedOption: '=ngModel',
                placeholder: '@',
                displayField: '@',
                selectedField: '@',
                name: '@',
                ngRequired: '=',
                errorKey: '@'
            },
            template: `
                <md-input-container flex="50" md-no-float>
                    <select
                        name="{{name}}"
                        ng-model="selectedOption"
                        ng-change="changeOptionSelect(selectedOption)"
                        tabindex="-1"
                        class="md-visually-hidden"
                        ng-options="option.selectedDisplayValue for option in options">
                    </select>
                    <md-select
                        placeholder="State"
                        ng-required="true"
                        md-no-asterisk
                        ng-model="selectedOption.code"
                        ng-change="changeOptionSelect(selectedOption)">
                        <md-option
                            data-ng-repeat="option in options"
                            value="{{option.code}}">
                        {{option.displayValue}}
                        </md-option>
                    </md-select>
                    <div class="md-errors-spacer"></div>
                </md-input-container>
            `,
            link: function postlink(scope, element) {
                scope.button = angular.element(element).find('button');
                scope.options = scope.availableoptions || [];

                scope.changeOption = (index) => {
                    if (index) {
                        //select the option on the hidden select dropdown
                        scope.selectedOption = scope.options[index];

                        //run the callback function
                        if (typeof scope.optionselect === 'function') {
                            scope.optionselect(scope.selectedOption);
                        }

                        //focus on the select element... the placeholder directive demands it.
                        scope.button.focus();
                    }
                };

                scope.changeOptionSelect = (selectedOption) => {
                    //select the option on the hidden select dropdown
                    //run the callback function
                    if (typeof scope.optionselect === 'function') {
                        scope.optionselect(selectedOption);
                    }

                    //focus on the select element... the placeholder directive demands it.
                    scope.button.focus();
                };

                scope.$watch('availableoptions', () => {
                    //Only change things up if we have the ability. If there's no options to show
                    //it means we shouldnt have focus. Preserve the data and dom when
                    //options are blank.
                    if (typeof scope.availableoptions !== 'undefined' && scope.availableoptions.length > 0) {
                        scope.options = scope.availableoptions.slice();
                        angular.forEach(scope.options, (option) => {
                            option.displayValue = option[scope.displayField || 'name'];
                            option.selectedDisplayValue = option[scope.selectedField || 'name'];
                        });
                    }
                });

                scope.$watch('selectedOption', (newValue) => {
                    if (newValue) {
                        scope.button.focus();
                    } else {
                        scope.button.blur();
                    }
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/addressEditor/addressEditorDropdown.directive.js